import { Upload } from '@runelab/odin-common'
import { saveAs } from 'file-saver'

export type AttachmentMessageProps = {
  attachment: Upload
  startsSequence?: boolean
  endsSequence?: boolean
  textClassName?: string
  align?: 'right' | 'left'
  borderClass?: string
}

export const AttachmentMessage = ({
  attachment,
  textClassName,
  align = 'left',
  borderClass,
}: AttachmentMessageProps) => {
  const leftAlign = align === 'left'

  const bgColor = leftAlign ? 'tw-bg-gray-100' : 'tw-bg-primary-500'

  const downloadFile = async () => {
    const filePath = attachment.full
    const fileName = attachment.additionalInfo?.fullName ?? attachment.originalName ?? attachment.full
    try {
      if (!filePath) return
      const file = await fetch(filePath)
      saveAs(await file.blob(), fileName)
    } catch (e) {
      console.error({ e })
    }
  }

  return (
    <div className={`tw-flex tw-flex-row tw-pl-[20px] ${leftAlign ? 'tw-justify-start' : 'tw-justify-end'}`}>
      <div className={`${bgColor} tw-px-[15px] tw-py-[4px] ${borderClass}`} onClick={downloadFile}>
        <span className={`tw-text-sm tw-underline ${textClassName}`}>
          {attachment.additionalInfo?.fullName ?? attachment.originalName ?? attachment.full}
        </span>
      </div>
    </div>
  )
}
